export { default } from './ContentRenderer';
